import { apiUrl }  from "../constants";
import * as moment from 'moment';
var axios = require('axios');
var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':localStorage.getItem('token'),'Content-Type':'multipart/form-data'}//application/json
})
export default class PlayersApi {
    static getAll(offset = 0, page = 30) {
        return request.get(`/players/${localStorage.getItem("rol")}/${offset}/${page}`);
    }

    static countAll(tournament = null, league = null) {
        return request.get(`/players/countAll/${tournament}/${league}`);
    }

    static getByTeam(team_id){
        return request.get(`/players/team/${localStorage.getItem("rol")}/${team_id}`);
    }

    static get(id) {
        return request.get(`/players/${localStorage.getItem("rol")}/${id}`);
    }

    static create(player) {
        var fd = new FormData()
        if(player.img != undefined)
            fd.append("img",player.img[0]);
        if(player.name != undefined)
            fd.append("name",player.name);
        if(player.birthday != undefined)
            fd.append("birthday",player.birthday);
        fd.append("team_id",player.team_id);
        if(player.dorsal != undefined)
            fd.append("number",player.dorsal);
        return request.post('/players',fd);
    }

    static edit(player){
        player.birthday = moment(player.birthday).format("DD/MM/YYYY")
        var fd = new FormData()
        if(player.img != undefined && player.img!="uploads/players/medium/default_player.png")
            fd.append("img",player.img[0]);
        if(player.name != undefined)
            fd.append("name",player.name);
        if(player.birthday != undefined)
            fd.append("birthday",player.birthday);
        fd.append("team_id",player.team_id);
        if(player.dorsal != undefined)
            fd.append("number",player.dorsal);
        if(player.status != undefined)
            fd.append("status",player.status);
        //id player
        fd.append("id",player.id);
        return request.post(`/players/edit`, fd);
    }

    static delete(id){
        return request.delete(`players?id=${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/api/Players.js